export const Errors = {
  validRegistration: 'Deverá introduzir matricula válida',
  validEmail: 'Deverá introduzir um email válido',
  passwordLength: 'Palavra-chave deverá ter no minimo 8 caracteres',
  validSamePassword: 'As Palavras-chave devem ser identicas',
  warningDeliveryReason: 'Máximo 8 caracteres',
  warningAllFieldsWithData: 'Todos os campos são de preenchimento obrigatório.',
  somethingWrong: 'Aconteceu alguma coisa inesperada, o seu pedido não foi aceite.',
  onlyNumerics: 'Só valores numéricos',
  noPods: 'sem Pods inserido(s) para este(s) pedido(s).',
  customerOrder: {
    error: {
      period: {
        exceeded: {
          '24h': 'Alteração de um pedido para um pequeno volume não é permitida até 24h antes da data de entrega.',
          '48h': 'Alteração de um pedido para um grande volume não é permitida até 48h antes da data de entrega.'
        }
      },
      reschedule: {
        unallowed: 'Alteração da data de entrega para um domingo não é permitida.'
      }
    }
  },
  pyxis: {
    change: {
      received: {
        not: {
          allowed: 'A alteração recebida não é permitida pelo Pyxis.'
        }
      }
    }
  },
  error: {
    emailexists: 'E-mail já existente, deverá seleccionar um outro válido.',
    cannot: {
      remove: {
        assigned: {
          orders: {
            in: {
              progress: 'Não se pode remover a matricula porque tem pedidos associados a ela. Deve remover a matricula a esses pedidos.'
            }
          }
        }
      }
    },
    user: {
      without: {
        associated: {
          carrier: 'Utilizador sem transportador asssociado.'
        }
      }
    },
    driver: {
      without: {
        associated: {
          vehicle: 'Motorista sem veiculo associado.'
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/translations/pt/errors.js